<template>
  <search-widget
    title="Ask CY"
    titleEnd="or Search Records"
    placeholder="How do I..., Mary McTesterson, Record Name"
    :searchAction="showCommandsDialog"
  />
</template>

<script>
import EventBus from '@/factories/eventBus';
import SearchWidget from '@/components/basic/search-widget/SearchWidget.vue';

export default {
  name: 'HomeSearch',
  components: {
    SearchWidget,
  },
  methods: {
    showCommandsDialog(search) {
      EventBus.$emit('openCommandModal', { search });
    },
  },
};
</script>
